import { Link } from "@fluentui/react";
import { FC, ReactElement } from "react";
import { FormattedMessage } from "react-intl";
import { BlankView, EmptyContainer } from "../Widgets/common";

interface BlankSearchWrapperProps {
  isLoading: boolean | null;
  hasConditions: boolean;
  clearQuery: () => void;
  noItemsText?: string;
  children: ReactElement;
}

const BlankSearchWrapper: FC<BlankSearchWrapperProps> = ({
  isLoading,
  hasConditions,
  clearQuery,
  noItemsText,
  children,
}) => {
  let emptyMesage = (
    <FormattedMessage id="details-list.no-items" defaultMessage="This page is empty" />
  );

  if (isLoading === null) {
    emptyMesage = (
      <FormattedMessage
        id="details-list.no-search"
        defaultMessage="No data yet. Click Search to display the items."
      />
    );
  }

  if (isLoading) {
    return <>{children}</>;
  }

  if (noItemsText) {
    return <EmptyContainer>{noItemsText}</EmptyContainer>;
  }

  return (
    <BlankView>
      {hasConditions && isLoading !== null ? (
        <div>
          <FormattedMessage
            id="details-list.no-found"
            defaultMessage="No objects were found. Would you like to "
          />
          <Link onClick={clearQuery}>
            <FormattedMessage id="details-list.reset-filter" defaultMessage="reset query" />
          </Link>
          ?
        </div>
      ) : (
        emptyMesage
      )}
    </BlankView>
  );
};

export { BlankSearchWrapper };
